

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { SHOW_SEARCH_OR_LOGIN } from "@/store/constants/ins_user_info_types";
import { CHANGE_CURRENT_INS_USER_ID } from "@/store/constants/index_types";
import Popup from "@/components/Popup/Popup.vue";
import NavBar from "@/components/NavBarNew/NavBar.vue";
import InsUserIner from "./insUser/InsUserIner.vue";
import AddAcount from "./insUser/AddAcount.vue";
@Component({
  components: { Popup, NavBar, InsUserIner, AddAcount }
})
export default class InsUserGallery extends Vue {
  @Action(SHOW_SEARCH_OR_LOGIN)
  private clickLoginSearch: any;
  @Action(CHANGE_CURRENT_INS_USER_ID)
  private changeCurrentInsUserId: any;
  @Prop()
  private value?: boolean;
  private popShow = false;

  @Watch("value", { immediate: true })
  private changePop(val: boolean, oldVal: boolean) {
    this.popShow = val;
  }
  @Watch("popShow", { immediate: true })
  private change(val: boolean, oldVal: boolean) {
    this.$emit("input", val);
  }

  private clolsePopup() {
    this.$emit("input", false);
  }

  private clickItem(val: string) {
    this.changeCurrentInsUserId(val);
    this.clolsePopup();
  }

  private clickSearch() {
    this.clickLoginSearch();
    this.clolsePopup();
  }
}
